import * as R from 'ramda';
import { requestWithAuthorization } from './requestWithAuthorization';
import { EventTriggerType } from '@/API';
import portalConfigure from '@/portal-configure';
import { ErrorInfo } from '@/types/type';

export const executeJobImmediately = async (
  jobId: string,
  loginName: string,
  eventTriggerType: EventTriggerType,
  startIndex: number,
  eventTitle: string | null = null
): Promise<void> => {
  await requestWithAuthorization
    .post(`${portalConfigure.API.schedulerJobExecute}`, {
      jobId,
      loginName,
      eventTriggerType,
      startIndex,
      eventTitle,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00007',
          title: 'Failed to trigger job execution',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });
};
